module.exports = __webpack_public_path__ + "media/react/admissions/organisms/status_message/assets/loading_state_complete-6e2c17e2c46621e5447dadcc1ed5d06a.svg";